import { render } from "./fieldCustomSubmit.vue?vue&type=template&id=f1224114"
import script from "./fieldCustomSubmit.vue?vue&type=script&lang=js"
export * from "./fieldCustomSubmit.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__